// extracted by mini-css-extract-plugin
export default {"tooltip":"xz-z","arrow":"yz-z"};